import React from 'react'
import { Link } from 'react-router'
import { useCommunityText } from 'utils'
import { Card, RenderedHtml } from 'components'
import {
  SchoolIcon,
  LearningHubCoursesIcon,
  PartnershipsIcon,
  InstructorsIcon,
} from 'components/icons'
import { LEARNING_HUB_ROUTE } from 'config'

const propTypes = {}

const defaultProps = {}

function Home() {
  const t = useCommunityText()

  return (
    <React.Fragment>
      <Card>
        <div className="rendered-html">
          <RenderedHtml>{t('learningHub.welcomeMessage')}</RenderedHtml>
        </div>
      </Card>
      <div className="to-do-blocks">
        <Card>
          <div className="value-block">
            <div className="value">
              <SchoolIcon />
            </div>
          </div>
          <div className="text-block">
            <h3>Access My Courses</h3>
            <p>View all your enrolled courses and track your progress.</p>
            <Link
              to={`${LEARNING_HUB_ROUTE}/my-courses`}
              className="button-primary button-small"
            >
              View My Courses
            </Link>
          </div>
        </Card>
        <Card>
          <div className="value-block">
            <div className="value">
              <LearningHubCoursesIcon />
            </div>
          </div>
          <div className="text-block">
            <h3>Browse Courses</h3>
            <p>
              Discover a range of learning opportunities designed to help you
              grow your skills and knowledge.
            </p>
            <Link
              to={`${LEARNING_HUB_ROUTE}/course-catalog`}
              className="button-primary button-small"
            >
              View Course Catalog
            </Link>
          </div>
        </Card>
        <Card>
          <div className="value-block">
            <div className="value">
              <PartnershipsIcon />
            </div>
          </div>
          <div className="text-block">
            <h3>General Forum</h3>
            <p>
              Engage with other learners to discuss various topics and share
              knowledge.
            </p>
            <Link
              to={`${LEARNING_HUB_ROUTE}/forum`}
              className="button-primary button-small"
            >
              Go to Forum
            </Link>
          </div>
        </Card>
        <Card>
          <div className="value-block">
            <div className="value">
              <InstructorsIcon />
            </div>
          </div>
          <div className="text-block">
            <h3>My Profile</h3>
            <p>Fill out details about yourself.</p>
            <Link
              to={`${LEARNING_HUB_ROUTE}/my-profile`}
              className="button-primary button-small"
            >
              Update Your Profile
            </Link>
          </div>
        </Card>
      </div>
    </React.Fragment>
  )
}

Home.propTypes = propTypes
Home.defaultProps = defaultProps

export default Home
